import React, { useEffect, useState } from "react";
import api from "../../services/api";

/**
 * Narrow a register to one client system, and then to one of its groups.
 *
 * The group select only appears once a client is chosen, because a group name
 * means nothing on its own -- every client has a "Savdo" -- and because
 * fetching every group of every client to populate one dropdown is the thing
 * this filter exists to avoid.
 *
 * The client list is fetched whole on purpose: it is a register of integrating
 * systems, a handful of rows, and it is the one list here that will not grow.
 */
const ClientGroupFilter = ({ client, group, onChange, withGroups = true }) => {
  const [clients, setClients] = useState([]);
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    let live = true;
    api
      .get("/clients/", { params: { limit: 200 } })
      .then((res) => live && setClients(res.data.results || []))
      .catch(() => live && setClients([]));
    return () => {
      live = false;
    };
  }, []);

  useEffect(() => {
    if (!client) {
      setGroups([]);
      return undefined;
    }
    let live = true;
    api
      .get("/groups/", { params: { client, limit: 500 } })
      .then((res) => live && setGroups(res.data.results || []))
      .catch(() => live && setGroups([]));
    return () => {
      live = false;
    };
  }, [client]);

  return (
    <>
      <select
        className="ms-select ms-select--sm"
        value={client}
        aria-label="Mijoz tizimi"
        // Changing client clears the group: the old group belongs to the old
        // client, and leaving it set would return nothing with no clue why.
        onChange={(e) => onChange({ client: e.target.value, group: "" })}
      >
        <option value="">Barcha mijoz tizimlari</option>
        {clients.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </select>

      {client && withGroups && (
        <select
          className="ms-select ms-select--sm"
          value={group}
          aria-label="Guruh"
          onChange={(e) => onChange({ client, group: e.target.value })}
        >
          <option value="">Barcha guruhlar</option>
          {groups.map((g) => (
            <option key={g.id} value={g.id}>
              {g.parent_id ? `— ${g.name}` : g.name}
            </option>
          ))}
        </select>
      )}
    </>
  );
};

export default ClientGroupFilter;
